<template>
	<c-dialog ref="dialog" width="800" height="560" enable-flex @resolve="submitHandle">
		<!-- 商品范围信息（批量入口恒按商品数展示，不降级为单产品信息） -->
		<div class="m-shelf-info flex">
			<p class="flex-grow ellipsis m-product-label">已选商品：<span class="m-product-name">{{productList.length}}个</span></p>
		</div>

		<!-- 批量上架说明：仅切换渠道上架状态，不改价、不发布商品 -->
		<div class="m-shelf-tip">仅对已发布渠道商品进行重新上架，且不支持调整价格</div>

		<!-- 暗拍/靓机选项卡切换：与单个上架一致，一次批量只能上一类渠道（二选一） -->
		<div class="m-channel-tabs">
			<div
				v-for="tab in channelTypeTabs"
				:key="tab.value"
				:class="['m-tab-item', { 'm-tab-active': channelType === tab.value }]"
				@click="switchChannelTab(tab)"
			>
				{{tab.name}}
			</div>
		</div>

		<!-- 不可上架的原因不在弹框堆文字：提交前看列表页渠道状态上的 ! 提示，提交后看未上架明细列表 -->

		<!-- 可上架渠道列表 -->
		<div class="m-shelf-table-area flex-column flex-grow">
			<c-table ref="list" :data="channelList" height="grow" :paging="false" empty-text="暂无可上架的渠道">
				<c-table-column type="selector" width="40"></c-table-column>
				<c-table-column label="上架渠道" name="channel_name" min-width="160"></c-table-column>
				<c-table-column label="渠道类型" width="100">
					<template #default="{data}">
						<span :class="data.is_dark_auction == 1 ? 'm-biz-dark' : 'm-biz-normal'">{{data.is_dark_auction == 1 ? '暗拍渠道' : '靓机渠道'}}</span>
					</template>
				</c-table-column>
				<c-table-column label="涉及商品" width="100">
					<template #default="{data}">{{data.product_count}}个</template>
				</c-table-column>
				<c-table-column label="当前状态" width="120">
					<template #default="{data}">
						<span v-if="data.has_off_shelf" class="m-state-off">已下架</span>
						<span v-else class="m-state-wait">待上架</span>
					</template>
				</c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleBatchShelfChannel',

		data() {
			return {
				/**暗拍/靓机选项卡（1暗拍渠道/2靓机渠道），与单个上架 shelf_channel_dialog 同口径*/
				channelTypeTabs: [{
					name: '靓机渠道',
					value: 2
				}, {
					name: '暗拍渠道',
					value: 1
				}],
				/**当前选项卡类型，默认靓机；一次批量只展示并提交该类渠道*/
				channelType: 2,
				productList: [],
				channelList: []
			}
		},

		methods: {
			/*********打开弹框（批量商品，仅渠道上架）**********/
			open(data) {
				this.productList = (data && data.list) || [];
				/**默认回到靓机选项卡，与单个上架一致；暗拍/靓机二选一，一次批量只上一类*/
				this.channelType = 2;
				/**buildChannelList 同时产出可上架渠道与排除原因清单*/
				this.channelList = this.buildChannelList();
				this.$refs.dialog.open({
					title: '批量上架',
					buttonName: '确定上架'
				});
			},

			/*********切换暗拍/靓机选项卡：重建当前类型下的可上架渠道列表（切换后表格数据替换，勾选自然重置）**********/
			switchChannelTab(tab) {
				if (this.channelType === tab.value) return;
				this.channelType = tab.value;
				this.channelList = this.buildChannelList();
			},

			/*********聚合可上架渠道（按渠道维度并集，统计每个渠道涉及的商品数）**********
			 * 预筛口径对齐后端 batchOnShelf（此处只减少无效勾选，最终以过滤后的置位结果为准）：
			 * 1.渠道已发布成功（channel_publish_state=2），批量不支持发布新商品；
			 * 2.未上架/已下架（已在售不重复上架）；
			 * 3.无在途同步任务（待同步/同步中不可覆盖任务类型）；
			 * 4.已有有效渠道售价（批量不改价，沿用原价）；
			 * 5.暗拍/靓机二选一：只保留当前选项卡类型的渠道，从交互上杜绝一次批量混提两类
			 * 质检报告与暗拍互斥需查库才能判定，弹框不预判，由后端过滤并进未上架明细*/
			buildChannelList() {
				var channelMap = {};
				var order = [];
				this.productList.forEach(product => {
					(product.channel_list || []).forEach(channel => {
						/**有排除原因即不可上架，不展示也不计数*/
						if (this.shelfExcludeReason(channel)) return;
						/**暗拍/靓机二选一：只展示当前选项卡类型的渠道（暗拍tab留 is_dark_auction=1，靓机tab留非暗拍），与后端整批拦同口径*/
						if ((this.channelType == 1) !== (channel.is_dark_auction == 1)) return;
						var item = channelMap[channel.channel_id];
						if (!item) {
							item = {
								channel_id: channel.channel_id,
								channel_name: channel.channel_name,
								is_dark_auction: channel.is_dark_auction,
								product_count: 0,
								has_off_shelf: false
							};
							channelMap[channel.channel_id] = item;
							order.push(channel.channel_id);
						}
						item.product_count++;
						if (channel.listing_state == 3) item.has_off_shelf = true;
					});
				});
				return order.map(channelId => channelMap[channelId]);
			},

			/*********不可批量上架的原因（返回空表示可上架，判定对齐后端 batchOnShelf 中弹框可自算的那部分）**********/
			shelfExcludeReason(channel) {
				if (channel.channel_publish_state != 2) return '商品未在该渠道发布';
				if (!(channel.sale_price > 0)) return '未设置该渠道售价';
				if (channel.listing_state == 2) return '已在售，无需重复上架';
				if (channel.sync_state == 2) return '正在同步中';
				if (channel.sync_state == 1) return '已有同步任务待执行';
				if (channel.listing_state != 1 && channel.listing_state != 3) return '渠道状态不可上架';
				return '';
			},

			/*********提交上架**********/
			submitHandle(stop, next) {
				stop();
				var selectedList = this.$refs.list.getData('selected');
				if (!selectedList.length) {
					this.$message({message: '请至少勾选一个要上架的渠道', type: 'warn'});
					return;
				}
				this.request({
					url: '/sale/product/batchOnShelf',
					data: {
						product_ids: this.productList.map(item => item.id),
						channel_id_list: selectedList.map(item => item.channel_id)
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.$emit('resolve');
						var failList = (data && data.fail_list) || [];
						/**有未上架明细就单独开列表展示原因，toast 只留汇总，避免长文案在提示条里放不下*/
						if (failList.length) {
							this.$nextTick(() => {
								this.globalDialog('saleBatchShelfResult', {
									data: data
								});
							});
						} else {
							this.$message({message: msg || '上架提交成功', type: 'success'});
						}
						/**破价已放行与未上架是两回事，另开控价提醒弹框（后开者层级更高）*/
						if (data && data.price_warn_count > 0) {
							this.$nextTick(() => {
								this.globalDialog('salePriceWarnResult', {
									data: data
								});
							});
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-shelf-info {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-product-label {
			color: #333;
		}

		.m-product-name {
			color: #1890ff;
		}
	}

	.m-shelf-tip {
        padding: 12px 0px;
        margin: 0 20px 10px;
		font-size: 13px;
		color: #e6a23c;
	}

	.m-channel-tabs {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0;
		margin: 0 auto 12px;
		padding: 4px;
		width: 320px;
		background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%);
		border-radius: 24px;
		border: 1px solid #bae0ff;

		.m-tab-item {
			flex: 1;
			padding: 10px 32px;
			text-align: center;
			font-size: 14px;
			color: #666;
			cursor: pointer;
			border-radius: 20px;
			transition: all 0.3s;
			user-select: none;

			&:hover:not(.m-tab-active) {
				color: #1890ff;
			}

			&.m-tab-active {
				background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
				color: #fff;
				font-weight: 500;
				box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
			}
		}
	}

	.m-shelf-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		::v-deep .c-table-body table tbody tr {
			&.is-selected {
				background-color: #fffbe6 !important;
			}
		}
	}

	.m-biz-dark {
		color: #722ed1;
	}
	.m-biz-normal {
		color: #fa8c16;
	}
	.m-state-off {
		color: #909399;
	}
	.m-state-wait {
		color: #e6a23c;
	}
</style>
